import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { MaskingString } from "../../components/common/Common";

import "../../css/style.css";
import okIcon from "../../img/icon/icon-ok.svg";

//아이디 찾기 완료
const FoundIDOKBranch = () => {
  const bh_id = localStorage.getItem("foundID");
  const [varMemberID,setMemberID] = useState();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //입력정보저장객체
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:false,gotoMain:1});

    const ilen = bh_id.length - 3;
    const memberID = MaskingString(bh_id,ilen,'*');
    setMemberID(memberID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content member-wrap">
      <HeaderBranchTitle varPageTitle={'아이디 찾기 완료'} varBackString='none'/>
      <div className="vh-content-body">
        <div className="sign-ok">
					<img src={okIcon} alt="" />
					<div className="info-txt">
						회원님의 아이디는
						<p className="ok-con">{varMemberID}</p>
						입니다.
					</div>			
					<div className="form-contoller bt-btn">
						<Link to={'/Branch/Login'} className="form-contoller-btn btn-yes" style={{width:"100%"}}>확인</Link>
					</div>
				</div>
			</div>
    </div>	
  );
}
export default FoundIDOKBranch;